"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeToMinutes = timeToMinutes;
function timeToMinutes(time) {
    // Split the input time string into three parts: hours (hh), minutes (mm), and period (AM/PM).
    var _a = time.split(/[:\s]/), hh = _a[0], mm = _a[1], period = _a[2];
    // Convert the hours and minutes to minutes since midnight.
    var minutes = parseInt(hh) * 60 + parseInt(mm);
    // Check if the period is "PM" and if the hour is not already 12 (noon).
    if (period === "PM" && hh !== "12") {
        // If it's "PM" and not noon, add 12 hours' worth of minutes to the total.
        minutes += 12 * 60;
    }
    else if (period === "AM" && hh === "12") {
        // Handle "12:00 AM" as midnight (00:00)
        minutes = 0;
    }
    return minutes;
}
